import React from 'react';
import RemoveUserAccountConnectorApollo from '@dietlabs/components/src/ApolloConnectors/UserSettings/RemoveAccount/RemoveUserAccount/RemoveUserAccountConnectorApollo';
import RemoveAccountConfrimContainer from './RemoveAccountConfrimContainer';

const RemoveAccountConfirmPage = () => {
    return (
        <RemoveUserAccountConnectorApollo>
            {RemoveAccountData => {
                return <RemoveAccountConfrimContainer {...RemoveAccountData} />;
            }}
        </RemoveUserAccountConnectorApollo>
    );
};

export default RemoveAccountConfirmPage;
